module.exports = __webpack_public_path__ + "small-handcoins.10129af953234e03ea43b7b55bd8ca58.png";